import React from 'react';
import PropTypes from 'prop-types';
import { imagePath } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

function InlineLoader(props) {
    return (
        <div className={dt(['text-center'])}>
            <img src={imagePath(props.context, 'inline-loader.gif')} alt="Load Spinner" />
        </div>
    );
}

InlineLoader.propTypes = {
    context: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default InlineLoader;
